import React, { useState, useEffect, useMemo } from 'react'
import { useGlobalState } from '../../store'
import ResourceGroupCard from './ResourceGroupCard'
import { useRef } from 'react'
import AirportShuttleRoundedIcon from '@material-ui/icons/AirportShuttleRounded'
import Actions from './Actions/'

import {
  ProjectTitle,
  ProjectColor,
  Resources,
  ResourceList,
  RelativeWrapper,
  StyledContainer,
  Project,
} from './styled'
import { Box } from '@chakra-ui/core'

const ProjectComponent = ({
  column,
  pickerSource,
  viewOptions,
  onClick,
  onResourceCardDrop,
  type,
  project,
  sortedProjectResources,
  sortedGroups,
  projectResources,
  usedProjectGroups,
  projectResourcesGroup,
  resourceTypes,
  collapsedProjects,
}) => {
  let ref = useRef(null)

  const [toggleCollapse, setToggleCollapse] = useState(false)
  const [visible, setVisibility] = useState(false)
  let projectResourceVisi = []
  let availableRides = 0
  let amountOfPeople = 0
  let vehiclesIds = []
  // get vehiclesIDs
  if (resourceTypes) {
    vehiclesIds = resourceTypes
      .filter((type) => type.name === 'Ligeiro' || type.name === 'Pesado')
      .map((s) => s._id)
  }

  projectResourceVisi = useMemo(
    () =>
      (projectResources || []).filter((r) => {
        if (viewOptions.type) {
          return r.type == viewOptions.type || r.role == viewOptions.type
        } else {
          return r
        }
      }),
    [projectResources]
  )
  sortedProjectResources.map((resource, a) => {
    if (typeof resource === 'object') {
      // console.log(resource)
      if (resource.cardType === 'users') {
        if (resource.attr && resource.attr.transport === '1') {
        } else {
          amountOfPeople += 1
        }
        //check if it needs a ride
      } else if (vehiclesIds.includes(resource.type)) {
        if (resource.limits && resource.limits.spaces) {
          availableRides += Number(resource.limits.spaces)
        }
      }
      // if(resource.)
    }
  })

  // onScreen = useOnScreen(ref, '0px')
  return (
    (projectResourceVisi.length >= 1 || !viewOptions.type) && (
      <ProjectColor
        className={`animated fadeIn ${project.id} projectContainerWrapper`}
        color={type && type.color}
        isSearch={viewOptions.type || viewOptions.search?.length > 0}
      >
        <ProjectTitle
          cursor={'pointer'}
          color={type && type.color}
          style={{
            // color: type ? type.color : '#676a7a'
            color: 'rgb(45, 47, 54)',
          }}
        >
          <Box position={'relative'} w={'100%'}>
            <span
              style={{
                cursor: 'pointer',
                // background: type ? type.color : ''
                background: 'rgb(45, 47, 54)',
              }}
              onClick={() => onClick(project.id, 'toggleProjectCollapse')}
            >
              {project.code}
            </span>{' '}
            <strong
              style={{
                cursor: 'pointer',
              }}
              onClick={() => onClick(project.id, 'project')}
            >
              {project.name}
            </strong>{' '}
            <Actions
              type={'project'}
              data={project}
              column={column}
              project={project}
            />
          </Box>
        </ProjectTitle>

        {!collapsedProjects.includes(project.id) ? (
          <Project key={project.id} className="projectContainer">
            <div {...project.props} style={{ position: 'relative' }}>
              <Resources>
                <ResourceList>
                  {!pickerSource &&
                    sortedGroups.map((group, i) => {
                      return (
                        <ResourceGroupCard
                          key={i}
                          group={group}
                          setVisibility={setVisibility}
                          viewOptions={viewOptions}
                          onClick={onClick}
                          usedProjectGroups={usedProjectGroups}
                          onResourceCardDrop={onResourceCardDrop}
                          projectResourcesGroup={projectResourcesGroup}
                          pickerSource={pickerSource}
                          column={column}
                          project={project}
                          projectResources={projectResources}
                          sortedProjectResources={sortedProjectResources}
                        />
                      )
                    })}
                  {pickerSource && (
                    <StyledContainer
                      groupName="userProject"
                      onDrop={(e) => {
                        onResourceCardDrop(column.id, project.id, null, e)
                      }}
                      getChildPayload={(index) => {
                        return {
                          ...sortedProjectResources.filter((r) => !r.accountId)[
                            index
                          ],
                          projectId: project.id,
                          columnId: column.id,
                          source: 'calendar',
                        }
                      }}
                      dragClass="project-ghost"
                      dropClass="project-ghost-drop"
                      dropPlaceholder={{
                        animationDuration: 150,
                        showOnTop: true,
                        className: 'drop-preview',
                      }}
                      dropPlaceholderAnimationDuration={200}
                    >
                      {sortedGroups.map((group, i) => {
                        return (
                          <ResourceGroupCard
                            group={group}
                            setVisibility={setVisibility}
                            pickerSource={pickerSource}
                            viewOptions={viewOptions}
                            column={column}
                            project={project}
                            onClick={onClick}
                            projectResources={projectResources}
                            usedProjectGroups={usedProjectGroups}
                            sortedProjectResources={sortedProjectResources}
                            onResourceCardDrop={onResourceCardDrop}
                            projectResourcesGroup={projectResourcesGroup}
                          />
                        )
                      })}
                    </StyledContainer>
                  )}
                </ResourceList>
              </Resources>
              <span
                // onClick={() => {
                //   setToggleCollapse(
                //     toggleCollapse === project.id ? null : project.id
                //   )
                // }}
                style={{
                  position: 'absolute',
                  fontSize: '.65em',
                  color: '#fff',
                  borderRadius: '3px',
                  padding: '0 .5em',
                  right: 0,
                  background:
                    type && amountOfPeople <= availableRides
                      ? type.color
                      : '#000',
                }}
              >
                <AirportShuttleRoundedIcon
                  style={{ width: '13px', height: '13px', marginLeft: '.2em' }}
                />{' '}
                {amountOfPeople}/{availableRides}
              </span>
            </div>
          </Project>
        ) : null}
      </ProjectColor>
    )
  )
}

export default React.memo(ProjectComponent, (prevProps, nextProps) => {
  // Custom comparison to prevent unnecessary re-renders
  return (
    prevProps.project._id === nextProps.project._id &&
    prevProps.column.id === nextProps.column.id &&
    prevProps.projectResources.length === nextProps.projectResources.length &&
    prevProps.pickerSource === nextProps.pickerSource &&
    prevProps.viewOptions?.viewType === nextProps.viewOptions?.viewType &&
    JSON.stringify(prevProps.projectResources) ===
      JSON.stringify(nextProps.projectResources)
  )
})
